import _classCallCheck from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import styled from 'styled-components';
import styles from './MiniGallery.style';
import { imageRenditions } from './config';
import ImageTextCard from '../../molecules/ImageTextCard';
import ImageGallerySlider from '../../molecules/ImageGallerySlider';
import GalleryModal from '../../organisms/GalleryModal';
import { parseGalleryJSON } from '../../../utils/utilityFunction';
import { siteConstants } from '../../../constants/globalConstants';
import componentAnalytics from '../../../constants/analyticsConstants';
var MiniGalleryBlock = styled.section.withConfig({
  componentId: "sc-de8jb6-0"
})(["", ";"], styles);
var MiniGallery = /*#__PURE__*/function (_React$Component) {
  _inherits(MiniGallery, _React$Component);
  var _super = _createSuper(MiniGallery);
  function MiniGallery(props) {
    var _this;
    _classCallCheck(this, MiniGallery);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onSelectIndex", function (indexValue) {
      _this.activateModal(indexValue);
      _this.setState({
        selectedIndex: indexValue
      });
    });
    _defineProperty(_assertThisInitialized(_this), "activateModal", function () {
      _this.setState({
        modalActive: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "deactivateModal", function () {
      _this.setState({
        modalActive: false
      });
    });
    _this.state = {
      selectedIndex: 0,
      modalActive: false
    };
    _this.activateModal = _this.activateModal.bind(_assertThisInitialized(_this));
    _this.deactivateModal = _this.deactivateModal.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(MiniGallery, [{
    key: "render",
    value: function render() {
      var miniGalleryData = this.props.miniGalleryData;
      if (!miniGalleryData) return null;
      var galleryData = parseGalleryJSON(miniGalleryData);
      var galleryModalDto = {
        modalActive: this.state.modalActive,
        allGalleryData: galleryData,
        selectedIndex: this.state.selectedIndex
      };
      var imageRenditionsObj = {
        imageRenditions: imageRenditions
      };
      return __jsx(MiniGalleryBlock, {
        className: "nva-mini-gallery ".concat(this.props.className, " gallery-tile"),
        id: "gallery-tile"
      }, __jsx("div", {
        className: "container"
      }, __jsx("div", {
        className: "col-xs-12 tile-wrapper"
      }, __jsx(ImageTextCard, {
        className: "nva-mini-gallery__image-text-card",
        headingText: miniGalleryData && miniGalleryData !== null && miniGalleryData !== void 0 && miniGalleryData.sectionHeadline ? miniGalleryData === null || miniGalleryData === void 0 ? void 0 : miniGalleryData.sectionHeadline : '',
        headingType: "h2",
        headingClassName: "nva-mini-gallery__heading gallery-heading",
        descriptionText: miniGalleryData && miniGalleryData.bodyText && miniGalleryData.bodyText.json ? miniGalleryData.bodyText.json : '',
        descriptionType: siteConstants.RICH_TEXT,
        paraClassName: "nva-mini-gallery__gallery-description gallery-description",
        linkTitle: "gallery",
        linkClassName: "nva-mini-gallery__gallerty-top-cta gallery-top-cta",
        linkStyleType: "secondary-anchor",
        srcSetSetting: imageRenditions,
        ctaSingle: miniGalleryData === null || miniGalleryData === void 0 ? void 0 : miniGalleryData.cta,
        dataAnalytics: {
          type: componentAnalytics.miniGallery.analyticsType.SECTION_CTA,
          value: miniGalleryData === null || miniGalleryData === void 0 ? void 0 : miniGalleryData.sectionHeadline,
          variation: ''
        }
      }), __jsx(ImageGallerySlider, {
        galleryData: galleryData,
        carouselType: "miniGalleryCarousel",
        tilesPerRow: 4,
        sliderPrefix: "four-tile",
        tileClassName: "nva-mini-gallery__four-tile four-tile",
        onSelectTile: this.onSelectIndex,
        srcSetSetting: imageRenditionsObj
      }))), this.state.modalActive && __jsx(GalleryModal, {
        onClose: this.deactivateModal,
        galleryModalData: galleryModalDto
      }));
    }
  }]);
  return MiniGallery;
}(React.Component);
MiniGallery.defaultProps = {
  miniGalleryData: '',
  inheritedstyles: {},
  className: ''
};
export default styled(MiniGallery).withConfig({
  componentId: "sc-de8jb6-1"
})(["", ";"], styles);